module.exports = __webpack_public_path__ + "static/media/tipo2.eb512b46.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/wish-list/Modal/tipo2.png
// module id = 2068
// module chunks = 0